<div class="flex items-center justify-start gap-x-8" [ngClass]="{ 'flex-row-reverse justify-between gap-x-0': isInverted() }">
    <div class="pl-3">
        <app-rating-chip class="md:hidden" [diagnosticRating]="rating()"></app-rating-chip>
    </div>

    <div class="flex flex-col">
        <div class="flex justify-between gap-x-1">
            <span class="malou-text-16--semibold md:malou-text-12--semibold sm:malou-text-10--semibold text-malou-text-title sm:w-7/12">
                {{ title() }}
            </span>

            <app-rating-chip class="hidden md:block" [diagnosticRating]="rating()"></app-rating-chip>
        </div>
        <span class="malou-text-12--regular text-malou-text">{{ text() }}</span>
    </div>
</div>
